<template>
  <v-ons-page id="favorites-page">
    <v-ons-toolbar class="home-toolbar">
      <div class="left">
        <v-ons-back-button>
        </v-ons-back-button>
      </div>
      <div class="center">My Favorites</div>
    </v-ons-toolbar>

    <v-ons-list>

      <v-ons-list v-for="type in favoriteProducts" :key="'type'+type.id">
        <v-ons-list-header>
          {{type.title}}
        </v-ons-list-header>

        <v-ons-list-item
          class="product-list-item"
          v-for="product in type.products"
          modifier="longdivider"
          :key="product.Name">
          <div class="center" @click="push(product)">
            <div v-html="product.NameSvgString"></div>
          </div>
          <div class="right" @click="toggleFavorite(product)">
            <i v-show="product.fav" class="fa fa-star"></i>
            <i v-show="!product.fav" class="fa fa-star-o"></i>
          </div>
        </v-ons-list-item>
      </v-ons-list>
    </v-ons-list>

    <div
      v-show="favoriteProducts.length === 0"
      class="flex-column flex-grow align-items-center justify-content-center">
      Go to product pages to add favorites.
    </div>

  </v-ons-page>
</template>

<script>
import Graphic from './Graphic'
import { appData } from '../data.js'

export default {
  name: 'favorites-list',
  data () {
    return {
      products: appData.state.products,
      types: appData.state.types,
      menuIsOpen: false
    }
  },
  methods: {
    push(product) {
      this.$emit('push-page', {
        extends: Graphic,
        onsNavigatorProps: {
          product: product,
        }
      });
    },
    toggleFavorite(product) {
      appData.toggleFavorite(product);
    }
  },
  computed: {
    favoriteProducts() {
                let productsGroupedByType = [];
                this.types.forEach(type => {
                    let t = type;
                    t.products = this.products.filter(p => p.type === type.id && p.fav);
                    if(t.products.length > 0) {
                        productsGroupedByType.push(t);
                    }
                });

                return productsGroupedByType;
            }
  },
  created() {
    let productsOfType = appData.state.products;
    let completedNames = [];
    let completedAreas = [];

    productsOfType.forEach(p => {

        let nameCallback = (result) => {
            p.NameSvgString = result;
            completedNames.push(p);
            productPushed();
        };

        let areaCallback = (result) => {
            p.ProductAreaSvgString = result;
            completedAreas.push(p);
            productPushed();
        };

        let productPushed = () => {
            if (completedAreas.length === productsOfType.length && completedNames.length === productsOfType.length) {
                this.products = productsOfType;
            }
        };

        nameCallback(p.NameSvg);
        areaCallback(p.DetailsSvg);
    });
}
}
</script>

<style scoped>
  .fa-star, .fa-star-o {
    color: #dcca72;
  }
</style>



// WEBPACK FOOTER //
// src/components/Favorites.vue